module.exports = __webpack_public_path__ + "img/img_actualites.1954073b.jpg";